import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { MigrateUserTypes } from "@/types";

export interface MigrateState {
  migrationInformation: MigrateUserTypes.MigrateUser;
}

const DEFAULT_MIGRATE_USER_STATE: MigrateState = {
  migrationInformation: null,
};

export default (state: MigrateState = DEFAULT_MIGRATE_USER_STATE, action: Action): {} => {
  if (action.type === ActionTypes.MIGRATE_USER_INFORMATION) {
    const { payload } = action;
    return {
      ...state,
      migrationInformation: payload,
    };
  } else if (action.type === ActionTypes.MIGRATE_USER_RESULT) {
    return {
      ...state,
      migrationInformation: null,
    };
  } else {
    return state;
  }
};
